import { RequestType, ImageQualityStatus } from '../../enums/index.js';
const DECIMATE = 64;
const OFFSET_BITS = Math.log2(DECIMATE);
export function replicateQualityOf(offset) {
    const distance = Math.abs(offset);
    return distance <= 1
        ? ImageQualityStatus.ADJACENT_REPLICATE
        : (ImageQualityStatus.FAR_REPLICATE + 1 / distance);
}
function nearbyFramesOfDecimation(decimate) {
    const frames = [];
    const first = -Math.floor((decimate - 1) / 2);
    for (let offset = first; offset < first + decimate; offset++) {
        if (offset !== 0) {
            frames.push({ offset, imageQualityStatus: replicateQualityOf(offset) });
        }
    }
    return frames;
}
function reverseBits(value, bits) {
    let reversed = 0;
    for (let bit = 0; bit < bits; bit++) {
        reversed = (reversed << 1) | ((value >> bit) & 1);
    }
    return reversed;
}
function gapAfterStage(index) {
    const level = index === 0 ? 0 : Math.floor(Math.log2(index)) + 1;
    return DECIMATE >> level;
}
const decimateStages = Array.from({ length: DECIMATE }, (_, index) => {
    const offset = reverseBits(index, OFFSET_BITS);
    const gap = gapAfterStage(index);
    return {
        id: `decimate${DECIMATE}At${offset}`,
        decimate: DECIMATE,
        offset,
        priority: 6 + index,
        requestType: RequestType.Thumbnail,
        retrieveType: 'default',
        nearbyFrames: gap > 1 ? nearbyFramesOfDecimation(gap) : undefined,
    };
});
const coarseInterleavedRetrieveStages = [
    {
        id: 'initialImages',
        positions: [0.5, -1],
        retrieveType: 'default',
        requestType: RequestType.Thumbnail,
        priority: 5,
        nearbyFrames: nearbyFramesOfDecimation(DECIMATE),
    },
    ...decimateStages,
    {
        id: 'errorRetrieve',
    },
];
export default coarseInterleavedRetrieveStages;
